import React from 'react';

import PaymentOptions from './PaymentOptions';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import TerminalSetup from './TerminalSetup';
import { useI18n } from '~Hooks';

const HandyPayments = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.PaymentsTitle')}>
      <PaymentOptions />
      <TerminalSetup />
    </HandyPageWrapper>
  );
};

export default HandyPayments;
